<template>
  <div>
    <div v-if="usersCount>1">
      <h2 class="body-1">{{ 'select student' | lang }}</h2>
      <v-radio-group v-model="userId">
        <v-radio
          v-for="user in users"
          :key="user.id"
          :label="user.name"
          :value="user.id"
        ></v-radio>
      </v-radio-group>
    </div>
    <div v-if="currentUser">
      <user-future-lessons></user-future-lessons>
      <user-debt-lessons></user-debt-lessons>
      <user-warnings></user-warnings>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserFutureLessons from '../components/lessons/UserFutureLessons.vue';
import UserWarnings from '../components/user/UserWarnings.vue';
import UserDebtLessons from '../components/lessons/UserDebtLessons.vue';

export default {
  name: 'Lessons',
  components: {
    UserDebtLessons, UserWarnings, UserFutureLessons,
  },
  data() {
    return {};
  },
  computed: {
    userId: {
      get() {
        const user = this.$store.getters.currentUser;
        return user ? user.id : null;
      },
      set(value) {
        this.$store.commit('setCurrentUserId', value);
      },
    },
    ...mapGetters(['users', 'usersCount', 'currentUser']),
  },
};
</script>
